import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HowItWorks.css';

function HowItWorks() {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleCard = (cardId) => {
    setExpandedCard(expandedCard === cardId ? null : cardId);
  };

  return (
    <div className="how-it-works-page">
      <section className="hiw-hero" style={{
        background: 'linear-gradient(135deg, #FF6B35 0%, #e55a2b 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Option 3: Pattern of small logos */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: 0.08,
          backgroundImage: 'url(/fit-logo.jpg)',
          backgroundSize: '150px 150px',
          backgroundRepeat: 'repeat',
          zIndex: 0
        }}></div>
        <div className="container" style={{position: 'relative', zIndex: 1}}>
          <div style={{backgroundColor: '#000', display: 'inline-block', padding: '20px 40px', borderRadius: '8px'}}>
            <h1 style={{color: 'white', margin: 0}}>How <span className="fit-inline"><span className="f-orange" style={{color: '#FF6B35'}}>F</span>-IT</span> Score Works</h1>
          </div>
          <p className="hero-tagline-mobile">Born from lived experience, built on psychology, driven by passion</p>
          <p className="lead">A complete system connecting individual wellbeing to workplace&nbsp;safety</p>
        </div>
      </section>

      {/* Start Anywhere Section */}
      <section className="start-anywhere">
        <div className="container">
          <h2 className="section-title">Start Anywhere, Scale Everywhere</h2>
          <p className="section-intro">There's no single starting point. Choose what works for your organisation today - whether that's a powerful presentation, hands-on workshop or the digital&nbsp;app.</p>
          <p className="section-intro-sub">Every entry point connects to the same authentic journey.</p>
          
          <div className="journey-options">
            <div className={`journey-card ${expandedCard === 'bounce' ? 'expanded' : ''}`} onClick={() => toggleCard('bounce')}>
              <div className="journey-icon">
                <img src="https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/lt4nn7hs_Messenger_creation_5DE362F2-3343-4991-AA55-312D6079F1CD.jpg" alt="It's Not About the Fall" style={{objectPosition: '20% center'}} />
              </div>
              <h3>"It's Not About the Fall"</h3>
              <p>Jason's powerful keynote presentation shares his personal story and introduces the F-IT concept. Perfect for leadership buy-in and cultural&nbsp;awareness.</p>
              <div className="journey-badge orange-badge">Speaking Engagement</div>
              
              {expandedCard === 'bounce' && (
                <div className="expanded-content">
                  <h4>What's Included:</h4>
                  <ul>
                    <li>60-90 minute keynote presentation</li>
                    <li>Jason's personal story and the birth of F-IT Score</li>
                    <li>Interactive Q&A session</li>
                    <li>Powerful insights into wellbeing and safety connection</li>
                  </ul>
                  <p><strong>Perfect for:</strong> Leadership teams, conferences, safety events, cultural kickoff sessions</p>
                  <Link to="/services/not-about-the-fall" className="learn-more-btn">Learn More →</Link>
                </div>
              )}
              <div className="expand-indicator">{expandedCard === 'bounce' ? '−' : '+'}</div>
            </div>

            <div className={`journey-card ${expandedCard === 'workshop' ? 'expanded' : ''}`} onClick={() => toggleCard('workshop')}>
              <div className="journey-icon">
                <img src="https://customer-assets.emergentagent.com/job_fit-brand-hub/artifacts/8mytee7n_screen.jpeg" alt="F-IT Workshop tablet showing Workshop Activity" />
              </div>
              <h3>The <span className="fit-inline"><span className="f-orange">F</span>-IT</span> Workshop</h3>
              <p>Interactive workshop where teams explore their own wellbeing, understand the F-IT scale, and learn to recognise when they're approaching dangerous decision-making.</p>
              <div className="journey-badge orange-badge">Hands-On Experience</div>
              
              {expandedCard === 'workshop' && (
                <div className="expanded-content">
                  <h4>What's Included:</h4>
                  <ul>
                    <li>3-hour interactive workshop (up to 2 sessions per day available)</li>
                    <li>Understanding the F-IT 0-10 scale</li>
                    <li>Personal wellbeing assessment exercises</li>
                    <li>Group discussions and real-world scenarios</li>
                  </ul>
                  <p><strong>Perfect for:</strong> Teams, departments, front-line workers</p>
                  <Link to="/services/fit-workshop" className="learn-more-btn">Learn More →</Link>
                </div>
              )}
              <div className="expand-indicator">{expandedCard === 'workshop' ? '−' : '+'}</div>
            </div>

            <div className={`journey-card ${expandedCard === 'trainer' ? 'expanded' : ''}`} onClick={() => toggleCard('trainer')}>
              <div className="journey-icon">
                <img src="https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/zz5fdv5i_20250723_133519.jpeg" alt="F-IT Train the Trainer" />
              </div>
              <h3><span className="fit-inline"><span className="f-orange">F</span>-IT</span> Train the Trainer</h3>
              <p>Equip your internal champions to deliver F-IT workshops. Build sustainable, long-term capability within your&nbsp;organisation.</p>
              <div className="journey-badge orange-badge">Build Internal Capacity</div>
              
              {expandedCard === 'trainer' && (
                <div className="expanded-content">
                  <h4>What's Included:</h4>
                  <ul>
                    <li>Comprehensive trainer certification programme</li>
                    <li>All workshop materials and resources</li>
                    <li>Ongoing support and updates</li>
                    <li>License to deliver F-IT workshops internally</li>
                  </ul>
                  <p><strong>Perfect for:</strong> HR teams, L&D professionals, internal facilitators</p>
                  <Link to="/services/train-the-trainer" className="learn-more-btn">Learn More →</Link>
                </div>
              )}
              <div className="expand-indicator">{expandedCard === 'trainer' ? '−' : '+'}</div>
            </div>

            <div className={`journey-card ${expandedCard === 'app' ? 'expanded' : ''}`} onClick={() => toggleCard('app')}>
              <div className="journey-icon">
                <img src="https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/e9ijjop0_IMG-20251015-WA0000.jpeg" alt="F-IT App" />
              </div>
              <h3>The <span className="fit-inline"><span className="f-orange">F</span>-IT</span> App</h3>
              <p>Daily check-ins, personal dashboards, and real-time wellbeing tracking. Give your people a private, confidential tool to monitor their own F-IT&nbsp;score.</p>
              <div className="journey-badge orange-badge">Digital Platform</div>
              
              {expandedCard === 'app' && (
                <div className="expanded-content">
                  <h4>What's Included:</h4>
                  <ul>
                    <li>Mobile app for iOS and Android</li>
                    <li>Daily and monthly wellbeing check-ins</li>
                    <li>Personal dashboard and trend tracking</li>
                    <li>Company dashboard with anonymized data</li>
                    <li>Real-time alerts and support access</li>
                  </ul>
                  <p><strong>Perfect for:</strong> Organisations wanting continuous wellbeing monitoring</p>
                  <Link to="/services/fit-app" className="learn-more-btn">Learn More →</Link>
                </div>
              )}
              <div className="expand-indicator">{expandedCard === 'app' ? '−' : '+'}</div>
            </div>

            <div className={`journey-card ${expandedCard === 'fyou' ? 'expanded' : ''}`} onClick={() => toggleCard('fyou')}>
              <div className="journey-icon">
                <img src="https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/ihv79jey_tim_speaker%20%281%29.jpeg" alt="F-YOU Workshops" />
              </div>
              <h3>The <span className="fit-inline"><span className="f-blue">F</span>-YOU</span> Workshops</h3>
              <p>Focus on organisational response. Help leadership understand how company culture and communication impact employee wellbeing and&nbsp;safety.</p>
              <div className="journey-badge blue-badge">Leadership Focus</div>
              
              {expandedCard === 'fyou' && (
                <div className="expanded-content">
                  <h4>What's Included:</h4>
                  <ul>
                    <li>Leadership workshop on organisational response</li>
                    <li>Understanding F-YOU scores and their impact</li>
                    <li>Building psychological safety</li>
                    <li>Creating supportive culture built on respect, value, and integrity</li>
                  </ul>
                  <p><strong>Perfect for:</strong> Senior leadership, management teams, HR</p>
                  <Link to="/services/fyou-workshops" className="learn-more-btn">Learn More →</Link>
                </div>
              )}
              <div className="expand-indicator">{expandedCard === 'fyou' ? '−' : '+'}</div>
            </div>

            <div className={`journey-card ${expandedCard === 'skills' ? 'expanded' : ''}`} onClick={() => toggleCard('skills')}>
              <div className="journey-icon">
                <img src="https://customer-assets.emergentagent.com/job_fitlaunch/artifacts/d2dugd0e_vecteezy_modern-communication-group-of-people-chatting-with-speech_50874898.jpg" alt="F-YOU Essential Skills" />
              </div>
              <h3><span className="fit-inline"><span className="f-blue">F</span>-YOU</span> Essential Skills</h3>
              <p>Communication skills are essential for creating a good culture. Develop the human connection skills that build psychological safety and trust - historically called "soft skills", but there's nothing soft about their&nbsp;impact.</p>
              <div className="journey-badge blue-badge">Communication Skills</div>
              
              {expandedCard === 'skills' && (
                <div className="expanded-content">
                  <h4>What's Included:</h4>
                  <ul>
                    <li>Essential communication skills grounded in respect, value, and integrity</li>
                    <li>Active listening and empathy development</li>
                    <li>Difficult conversations workshop</li>
                    <li>Building trust and psychological safety</li>
                  </ul>
                  <p><strong>Perfect for:</strong> Managers, team leaders, anyone in people-facing roles</p>
                  <Link to="/services/essential-skills" className="learn-more-btn">Learn More →</Link>
                </div>
              )}
              <div className="expand-indicator">{expandedCard === 'skills' ? '−' : '+'}</div>
            </div>
          </div>

          <div className="journey-flow">
            <p className="journey-flow-text">→ Start with what resonates → Expand as you see results → Build a complete culture of wellbeing →</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HowItWorks;
